//Die Funktion explizit an window binden => globaler scope, sonst funktionert onclick-event nicht
window.scrollToTop = function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}
